import { useQuery } from '@tanstack/react-query';
import { pipelineNodeService } from '../services/pipelineNode.service';
import type { PipelineNode } from '../services/pipelineNode.service';

export function usePipelineNode(nodeId: string | null) {
  return useQuery<PipelineNode>({
    queryKey: ['pipeline-node', nodeId],
    queryFn: () => {
      if (!nodeId) {
        throw new Error('Node ID is required');
      }
      return pipelineNodeService.findById(nodeId);
    },
    enabled: !!nodeId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false, // the editor holds unsaved edits; don't refetch when the user tabs back
  });
}

